<template>
    <div>
		
		<!-- 电脑端日歷 -->
		
		<div class="pcelcalendar" v-if="!$store.getters.ismobilePhone">
			
        <el-calendar id="calendar" v-model="value" >
		
            <template
                    slot="dateCell"
                    slot-scope="{date, data}">
                <div>
                    <div class="data.isSelected ? 'is-selected' : ''" v-if="custTaskAdd" @click="handleAddClick(data.day)" style=" text-align:center;">{{ data.day.split('-').slice(2).join('-') }}<span style="color: black; float: right;"><i class="el-icon-plus" /></span></div>
                    <div class="data.isSelected ? 'is-selected' : ''" v-else style=" text-align:center;">{{ data.day.split('-').slice(2).join('-') }}<span style=" color: black; float: right;"><i class="fa el-icon-plus" /> </span></div>
                    <div v-for="(item,i) in Calendar">
                       <div v-if="(item.calendarDate.slice(0,4)).indexOf(data.day.slice(0,4))!=-1">
                            <div v-if="(item.calendarDate.split('-').slice(1)[0]).indexOf(data.day.split('-').slice(1)[0])!=-1">
                                <div v-if="(item.calendarDate.split('-').slice(2).join('-').slice(0,2)).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
                                    <div class="fc-day-grid-event" >
										<!-- id="fc-eventone" -->
                                        <div :id="i%2==0?'fc-eventone':'fc-eventone2'" v-if="custTaskEdit" @click="handleEventClick(item.id)">{{item.salesName}}：{{ item.remark.length>17?item.remark.slice(0,17) + '...':item.remark }}</div>
                                        <div :id="i%2==0?'fc-eventone':'fc-eventone2'" v-else>{{item.salesName}}：{{ item.remark.length>17?item.remark.slice(0,17) + '...':item.remark}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </el-calendar>
		<!-- 搜索按钮 -->
		<div style="float: left; margin-top: -1030px;margin-left: 130px;">
		    <router-link tag='a' :to="'/calenList'" style="text-decoration: none;color: #fff;"><el-button v-if="!$store.getters.ismobilePhone"  size="mini" ><i class="fa fa-search" /> 搜索</el-button></router-link>
		</div>
</div>
<!-- 手机端日歷 -->
<div class="moblieElcalendar" v-if="$store.getters.ismobilePhone" >
		
	<el-calendar id="calendar" v-model="value" >
	
	    <template
	            slot="dateCell"
	            slot-scope="{date, data}">
				  <div>
				 	            <div  @click="queryTask(data.day,0)" style="text-align:center;width: 30px;height: 30px;">

							{{ data.day.split('-').slice(2).join('-')}}
				 								<div v-for="item in datalist">
													<div v-if="item==data.day"  style="background-color: rgba(39,116,244,0.2);color:#4B78FF;width: 28px;height: 28px;border-radius:13px;margin-top: -25px;">
														
													
														</div>
														
								        
													</div>
											
											
											
				 					    	
				 					            
				 					        
				 				
				 				
									
				 				
				 				</div>
				 <!-- 	            <div class="data.isSelected ? 'is-selected' : ''" v-else style=" text-align:center;">{{ data.day.split('-').slice(2).join('-') }}aaaaa</div>
				  -->	         <!--   <div v-for="(item,i) in Calendar">
				 	               <div v-if="(item.calendarDate.slice(0,4)).indexOf(data.day.slice(0,4))!=-1">
				 	                    <div v-if="(item.calendarDate.split('-').slice(1)[0]).indexOf(data.day.split('-').slice(1)[0])!=-1">
				 	                        <div v-if="(item.calendarDate.split('-').slice(2).join('-').slice(0,2)).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
				 	                           
				 	                        </div>
				 	                    </div>
				 	                </div>
				 	            </div> -->
				 	        </div>

				
				
	       
	    </template>
	</el-calendar>
	<div v-if="addDate!=null" style="color:#4B78FF ;" @click="handleAddClick(addDate)">新增行程</div>
	<div v-for="item in msglist" style="width: 100%;background-color: white;margin-top: 20px;">
<div style="width: 100%;height: 20px;" >
	<div class="rightDate">
		{{item.taskMsg.calendarDate.split('-').slice(2).join('-').slice(0,2)}}
		<div @click="appFileUp(item.taskMsg.id)" > <!-- @click="fileListEdit(item.id)" -->
			
			<i class="el-icon-plus"></i>
			</div>
	</div>

	
</div>
<div style="color:#333333;font-size: 17px;font-weight: bold;margin-left: 10px;margin-top: 5px;width: 100%;height: 30px;">{{item.taskMsg.calendarDate}} {{item.taskMsg.startDate}}-{{item.taskMsg.endDate}}</div>
	<div style="color:#666666;font-size: 17px;font-weight: bold;margin-left: 10px;margin-top: 5px;width: 100%;">銷售員：{{item.taskMsg.salesName}}</div>
	<div style="color:#666666;font-size: 17px;font-weight: bold;margin-left: 10px;margin-top: 5px;width: 100%;">地址：{{item.taskMsg.place}} </div>
	<div style="color:#666666;font-size: 17px;font-weight: bold;margin-left: 10px;margin-top: 5px;width: 100%;padding-bottom: 20px;">內容：{{item.taskMsg.remark}}</div>
	<div v-for="imglist in item.imgFile">
		<img @click="handleChangeImg($event)"  :src="appGetImgeUrl(imglist.relativePath)" class="taskImg"/>
		 <el-button  @click="deleteCustFile(null, imglist)">
			 删除
		 </el-button>
		
	<!-- <el-button  @click.native="deleteCustFile("", imglist)">{{$t('m.b_delete')}}</el-button> -->
	</div>
	</div>
</div>
        <el-dialog :title="optTitle" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="taskForm"  :rules="taskRules" ref="taskForm" label-width="100px" size="small">
                <el-row :gutter="0">
                <el-col :span="24">
                    <el-form-item :label="$t('m.t_salesName')+'：'" prop="salesId">
                        <el-select v-model="taskForm.salesId"  filterable remote placeholder=""  style="width:180px">
                            <el-option
                                    v-for="item in salesOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.loginName }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_place')+'：'" prop="place">
                            <el-input v-model="taskForm.place" placeholder="" auto-complete="off" style="width:180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_calendarStartdate')+'：'"  prop="startDate">
                            <el-time-select
                                    v-model="taskForm.startDate"
                                    placeholder="" style="width:180px"

                                    :picker-options="{
                                    start: '00:00',
                                    step: '00:15',
                                    end: '24:00'
                                  }">
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_calendarEnddate')+'：'" prop="endDate">
                            <el-time-select
                                    v-model="taskForm.endDate"
                                    placeholder="" style="width:180px"

                                    :picker-options="{
                                    start: '00:00',
                                    step: '00:15',
                                    end: '24:00',
                                  }">
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_remarks')" prop="remark">
                            <el-input
                                    type="textarea"
                                    :autosize="{minRows: 8, maxRows:18}"
                                    placeholder=""
                                    v-model="taskForm.remark"
									
									>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <el-row>
            <el-button v-if="taskForm.id&&canFile" type="warning" style="float: left;" @click.native="fileListEdit(taskForm.id)">{{$t('m.t_enclosureadmin')}}</el-button>

            <el-button v-if="taskForm.id&&custTaskDelete&&custTaskEditAll" type="warning" style="float: left;" @click="delEvent(taskForm.id)">删 除</el-button>
            <el-button v-else-if="taskForm.id&&custTaskDelete&&staff.id==taskForm.salesId" type="warning" style="float: left;" @click="delEvent(taskForm.id)">删 除</el-button>

            <el-button v-if="custTaskEditAll" type="primary" @click="saveEvent">确 定</el-button>
            <el-button v-else-if="staff.id==taskForm.salesId" type="primary" @click="saveEvent">确 定</el-button>
            <el-button style="float: right;"  @click="dialogFormVisible = false">取 消</el-button>
            </el-row>
            </el-form>
        </el-dialog>

        <!-- 附件管理-->
        <el-dialog :title="dialogFileListName" :visible.sync="dialogFileListVisible" width="80%">
            <div>
                <div style="float:right">
                    <el-button type="warning" @click="custFileAdd" v-if="canFileAdd&&custTaskEditAll"><i class="fa fa-cloud-upload" />{{$t('m.b_uploadfile')}}</el-button>
                    <el-button type="warning" @click="custFileAdd" v-else-if="canFileAdd&&staff.id==taskForm.salesId"><i class="fa fa-cloud-upload" />{{$t('m.b_uploadfile')}}</el-button>
                    <div style="height: 10px"></div>
                </div>
                <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                        v-loading="tableloading"
                        @selection-change="handleSelectionFileChange"
                        :data="fileList"
                        :empty-text="$t('m.t_nodata')"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="fileName"
                            align="left"
                            width="160"
                            :label="$t('m.t_filename')">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="top" v-if="pictureImg(scope.$index, scope.row)">
                                <p><img :src="getImageUrl(scope.$index, scope.row)" style="width: 100px;height: 100px"/></p>
                                <div slot="reference" class="name-wrapper">
                                    <el-tag size="medium"><a href="#" @click="openFile(scope.$index, scope.row)">{{scope.row.fileName}}</a></el-tag>
                                </div>
                            </el-popover>
                            <a href="javascript:void(0)" @click="fileDownload(scope.$index, scope.row)" v-if="canFileDow&&!pictureImg(scope.$index, scope.row)">{{scope.row.fileName}}</a>
                            <span v-if="!canFileDow&&!pictureImg(scope.$index, scope.row)">{{scope.row.fileName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="comment"
                            align="left"
                            :label="$t('m.t_remarks')">
                    </el-table-column>
                    <el-table-column
                            prop="uploadBy"
                            align="left"
                            width="120"
                            :label="$t('m.t_uploadby')">
                    </el-table-column>
                    <el-table-column
                            prop="tel2"
                            align="left"
                            width="160"
                            :label="$t('m.t_uploadtime')">
                        <template slot-scope="scope">
                            {{scope.row.uploadTime*1000 | date('%Y-%m-%d %T') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            align="center"
                            width="100"
                            :label="$t('m.b_opt')" v-if="canFileDow||canFileDel">
                        <template slot-scope="scope">
                            <template>
                                <el-dropdown>
                                    <el-button size="small" type="primary">
                                        <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  @click.native="fileDownload(scope.$index, scope.row)" v-if="canFileDow"><i class="fa fa-download"/> {{$t('m.t_download')}}</el-dropdown-item>

                                        <el-dropdown-item  @click.native="deleteCustFile(scope.$index, scope.row)" v-if="canFileDel&&custTaskEditAll"><i class="fa fa-trash"/>{{$t('m.b_delete')}}</el-dropdown-item>
                                        <el-dropdown-item  @click.native="deleteCustFile(scope.$index, scope.row)" v-else-if="canFileDel&&staff.id==taskForm.salesId"><i class="fa fa-trash"/>{{$t('m.b_delete')}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        layout="total, prev, pager, next"
                        @current-change="handleFileListChange"
                        :current-page.sync="fileListPager.page"
                        :page-size="fileListPager.size"
                        :total="fileListPager.total">
                </el-pagination>
            </div>
            <div style="height: 50px">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFileListVisible = false"> 關閉</el-button><!-- {{$t('m.b_cancel')}} -->
            </div>
        </el-dialog>

        <!-- 附件上傳页面-->
        <el-dialog :title="dialogFileName" :visible.sync="dialogFileVisible" width="400px">
            <el-form  :model="custFile"  :rules="custFileRules" ref="custFile" label-width="100px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_file')" prop="file">
                            <div>
                               <div><a href='javascript:void(0);' class="blueButton">{{$t('m.t_selectthefile')}}</a>
                                <input type="file" id="file" @change="getFile($event)" class="myFileUpload" multiple />
                                </div> <!-- <div class="show" id="file_name"></div> -->
								<div style="padding-top: 30px;"  >
								<div v-for="item in fileName">
									{{item}}
									</div>
								
								</div>
                            </div>
							 
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_remarks')" prop="comment">
                            <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="custFile.comment">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFileVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary" @click="custFileSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import {getTaskCalendarList,insertTaskCalendar,updateTaskCalendar,getTaskCalendarById,deleteTaskCalendarById,imageUrl,getCustFileList,deleteCustFile,getStaffAllList} from '../api/api'
export default {
        data: function() {
            var validateFile=(rule, value, callback) => {
                if (value==""){
                    document.getElementById("file_name").innerHTML=this.$t('m.t_selectthefile');
                    callback(new Error(' '));
                }
                callback();
            };
        return {
            pickerOptions0:{
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            Calendar: [],
            taskForm: {
             id: '',
             taskDate: '',
             remark:'',
             calendarDate:'',
            startDate:'',
            endDate:'',
            place:'',
            salesId:'',
            },
			addDate:'',//添加行程时间
			fileList:[],//文件list
			fileName:[],//文件名称list
            taskRules:{
                salesId: [
                    {required: true, message: this.$t('m.m_pleaseSalesName'), trigger: 'change'},
                ],
                place: [
                    {required: true, message: this.$t('m.m_pleasePlace'), trigger: 'change'},
                ],
                startDate: [
                    {required: true, message: this.$t('m.m_pleaseStartdate'), trigger: 'change'},
                ],
                endDate: [
                    {required: true, message: this.$t('m.m_pleaseEnddate'), trigger: 'change'},
                ],
                remark: [
                    {required: true, message: this.$t('m.m_remarks'), trigger: 'change'},
                ],
            },
            salesOptions:[],
            calendarEvents: [],
            dialogFormVisible: false,
            optTitle: '新增日歷',
			
            loading: false,
            value: new Date(),
             optValue:0,
            fileList:[],
            addEidtloading:false,
            dialogFileListVisible:false,
            dialogFileVisible:false,
            dialogFileListName:'',
            dialogFileName:'',
			datalist:[],//记录日期事件時間
			msglist:[],//事情数组
			forid:-1,//循环id
            fileListPager:{
                page:0,
                size:10,
                total:0
            },
            tableloading:false,
            fileId:[],
            oldFileId:[],
            custFile:{
                file:"",
                comment:""
            },
            custFileRules: {
                file:[
                    {required: true, validator: validateFile,trigger: 'change' }
                ],
                comment:[
                    {required: false, message: this.$t('m.m_remarks'), trigger: 'change' }
                ]
            },
        }
        },
        mounted() {

        },
    activated(){
        this.loading = true;
        this.getStaffAllList();
        this.getTaskCalendarLists();
		
		// console.log(this.Calendar);
		// $('#calendar').prepend('<div style="height: 2.1em;line-height:2.1em">'+
		//           '<input type="radio" name="data_type" value="0" onclick="onDataTypeclick(this)" checked><span>開始時間</span>'+
		//           '<input type="radio" name="data_type"value="1" onclick="onDataTypeclick(this)"><span>結束時間</span></div>'); 
        },
        methods: {
            getStaffAllList(){
                getStaffAllList().then(data=>{
                    let {data:res={}}=data;
                    this.salesOptions=res.data;
				
                });
				//this.Calendar[0].calendarDate
				//datalist
			
			//console.log(this.datalist);
            },
			
            getSalseVal(val){
                let  obj=this.salesOptions.find(v=>v.id==val);
                if(obj==undefined){
                    return "";
                }else {
                    return obj.name;
                }
            },
            handleSelectionFileChange(){},
            handleFileListChange(val){
                this.getCustFileList();
            },
			appGetImgeUrl(fileUrl)
			{
				return imageUrl(fileUrl);
			},
            getImageUrl(index,row){
                let fileUrl=row.relativePath;
				
                return imageUrl(fileUrl);
            },
            openFile(index,row){
                let fileUrl=row.relativePath;
                window.open(imageUrl(fileUrl));
            },
            pictureImg(index,row){
                let  url=row.fileUrl;
                let  suffixName=url.substr(url.lastIndexOf(".")).toLowerCase();//获得文件后缀名
                var strFilter=".jpeg|.gif|.jpg|.png|.bmp|.pic|";
                if(strFilter.indexOf(suffixName)>-1){
                    return true;
                }else{
                    return false;
                }
            },
			//手机端上传文件
			appFileUp(value)
			{
			   this.returnId=value;
			   console.log(value);
				 this.custFileAdd();
			},
			handleChangeImg($event){
			        if($event.currentTarget.className=='taskImg'){
			            $event.currentTarget.className='taskImg open';
			        }else{
			            $event.currentTarget.className='taskImg';
			        }
			    },
            fileListEdit(value){
				  console.log(value);
                this.dialogFileListName = this.$t('m.t_enclosureadmin');
                this.dialogFileListVisible = true;
                this.returnId=value;
                this.getCustFileList();
            },
			
            getCustFileList(){
                if(this.returnId!="" || this.returnId!=undefined) {
                    var params = {
                        page: this.fileListPager.page,
                        size: this.fileListPager.size,
                        taskId: this.returnId,
                        typeId: 2,
                    };
                    getCustFileList(params).then(data => {
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            let {size,page,total,data:items=[]}=res.data;
                            this.fileList=items;
							console.log(this.fileList);
                            this.fileListPager.total=total;
                            this.fileListPager.page=page;
                            this.fileListPager.size=size;
                            this.tableloading=false;
                        }else {
                            this.$message.error(res.errmsg);
                        }
                    });
                }
            },
            custFileAdd(){
                this.dialogFileName=this.$t('m.b_uploadfile');
                this.dialogFileVisible=true;
				this.clearFile();
                //重置file
                var file = document.getElementById('file');
                if(file!=null||file!=undefined){file.value="";}
                var fileValue=document.getElementById("file_name");
                if (fileValue!=null||fileValue!=undefined){fileValue.innerHTML="";}
                this.resetForm("custFile");
            },
            getFile(event){
				 if(event.target.files[0]!=undefined&&event.target.files[0]!=null) {
				                    //this.uploadFile.file = event.target.files[0];
				                    let upFile =event.target.files;
									console.log(upFile);
				                    for( var i=0;i<upFile.length; i++ ) {
				                        this.fileList.push(upFile[i]);
				                        this.fileName.push(upFile[i].name);
				                    }
				                }
				
				
                // if(event.target.files[0]!=undefined&&event.target.files[0]!=null) {
                //     this.custFile.file = event.target.files[0];
                //     document.getElementById("file_name").innerHTML = this.custFile.file.name;
                // }
            },
			clearFile()
			{
				this.fileList = [];
				this.fileName = [];
			},
            custFileSave(){
                // this.$refs.custFile.validate((valid) => {
                //     if (valid) {
                        // let fileSize=this.custFile.file.size/1024;
                        // if (fileSize>50000){
                        //     this.$message.warning(this.$t('m.b_uploadfileMaxFiftyMb'));
                        //     return;
                        // }
// console.log(this.fileList);
                        //阻止元素发生默认的行为
                        event.preventDefault();
						  for( var i=0;i<this.fileList.length; i++ ) {
                        var token=JSON.parse(window.sessionStorage.getItem("staff")).token;
                        var paramData = new FormData(); //创建form对象
                        paramData.append("file",this.fileList[i])//this.custFile.file);//通过append向form对象添加数据
                        //paramData.append("comment",this.custFile.comment);//通过append向form对象添加数据
                        paramData.append("typeId",2);//通过append向form对象添加数据
                        paramData.append("taskId",this.returnId);//通过append向form对象添加数据*/
                        let config = {
                            headers:{
                                'Content-Type':'multipart/form-data',
                                'Authorization':token
                            }
                        };
                        this.$http.post(axios.defaults.baseURL+'/fileUpload/upload', paramData,config).then(function (res) {
                            let item = res.data;
                            if (item.errcode === 200) {
                                this.$message.success(this.$t('m.m_uploadsuccess'));
                                this.getCustFileList();
                                this.resetForm("custFile");
                                this.dialogFileVisible=false;
							     this.clearFile()
								if(this.$store.getters.ismobilePhone)
								{
									this.getTaskCalendarLists();
									//手机端刷新行程列表
								}

                                //重置file
                                var file = document.getElementById('file');
                                file.value='';
                                document.getElementById("file_name").innerHTML="";
                            }
                        })
                    }
					// }
     //            });
            },
           
			deleteCustFile(index,row){
                this.$confirm(this.$t('m.m_deleteconfirm'),this.$t('m.m_info'), {
                    confirmButtonText:this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(() => {
                    deleteCustFile(row.id).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_deletesuc'));
                            this.getCustFileList();
							if(this.$store.getters.ismobilePhone)
							{
								this.getTaskCalendarLists();
								//手机端刷新行程列表
							}
                        }else{
                            this.$message.error(errmsg);
                        }
                    });
                });
            },
            fileDownload(index,row){
                window.location.href=axios.defaults.baseURL+'/fileDownload?id='+row.id;
            },

        getTaskCalendarLists(){
            getTaskCalendarList().then(result => {
                let {data:res={}}=result;
                this.Calendar = res.data;
				for(var i=0;i<this.Calendar.length;i++)
				{
					var cdata=this.Calendar[i].calendarDate;
				    // console.log(this.Calendar[i].id);
					var cdbool=false;
					for(var j=0;j<this.datalist.length;j++)
					{
						if(cdata==this.datalist[j])
						{
							cdbool=true;
							
						}
						
					}
					if(!cdbool)
					this.datalist.push(cdata);
				}
				if(this.addDate!=null)
						{						
						this.queryTask(this.addDate,0);//刷新添加行程
					}
				// console.log(this.datalist);
				
            });
        },
		
		
        ToDate(tim) {//時間处理
            const d = new Date(tim)
            d.setHours(0, 0, 0, 0);
            return tim = d.setHours(0, 0, 0, 0)
        },
        // 返回 类似 2016-01-02 格式的字符串
        formatDate(year, month, day) {
            var y = year
            var m = month
            if (m < 10) m = '0' + m
            var d = day
            if (d < 10) d = '0' + d
            return y + '-' + m + '-' + d
        },
		queryTask(date,state)
		{
			if(state==0)
			{
			this.msglist=new Array();
			this.addDate=date;
			this.forid=-1;
			}
				this.forid++;
				if(this.forid<this.Calendar.length)
				{
				 var s=this.Calendar[this.forid].calendarDate;
				  
				   if(s==date)
				   {
					  var params = {
					      page: 0,//this.fileListPager.page,
					      size:10,// this.fileListPager.size,
					      taskId:this.Calendar[this.forid].id, //this.returnId,
					      typeId: 2,
					  }; 
					  getCustFileList(params).then(data => {
					      let {data:res={}}=data;
					      if(res.errcode==200){
					          let {size,page,total,data:items=[]}=res.data;
					          // this.fileList=items;
					  		 this.msglist.push({"taskMsg":this.Calendar[this.forid],"imgFile":items});
					     // console.log(this.msglist);
						   this.queryTask(date,1);
					      }else {
					          this.$message.error(res.errmsg);
					      }
					  });
					  }
					  else
					  {
						 this.queryTask(date,1);  
					  }
				   
			}
			 // for(var i=0;i<this.Calendar.length;i++)
			 // {
				// 		   var s=this.Calendar[i].calendarDate;
				// 		   if(s==date)
				// 		   {
				// 		    this.msglist.push(this.Calendar[i]);
				// 		  }
			 // }
			 // this.$router.go(0);
			  // console.log(this.Calendar);
		},
		//app版本获取附件所有
		// appGetCustFileList(valueid,date)
		// {
		// 	    var params = {
		// 	        page: 0,//this.fileListPager.page,
		// 	        size:10,// this.fileListPager.size,
		// 	        taskId:valueid, //this.returnId,
		// 	        typeId: 2,
		// 	    };
		// 	    getCustFileList(params).then(data => {
		// 	        let {data:res={}}=data;
		// 	        if(res.errcode==200){
		// 	            let {size,page,total,data:items=[]}=res.data;
		// 	            this.fileList=items;
						
					
		// 	        }else {
		// 	            this.$message.error(res.errmsg);
		// 	        }
		// 	    });
		
		// },
		
        // 新增
        handleAddClick(date) {
			  // console.log('====='+date)
			 // console.log(this.dataBgState)
			// console.log(this.Calendar);
			 // if(this.Calendar[20].hasOwnProperty("calendarDate"))
			 // console.log('calendarDatek不为空')
			 // else
			 //  console.log('calendarDatek为空')
			 // console.log(this.Calendar[0].calendarDate.slice(0,4));
			 //  console.log(this.Calendar[0].calendarDate.split('-').slice(1)[0]);
			 //  console.log(this.Calendar[0].calendarDate.split('-').slice(2).join('-').slice(0,2));
          
		   
		   //------添加日歷事情
		 
		  
			this.resetForm("taskForm");
            this.dialogFormVisible = true
            this.optTitle = '新增日歷';
            this.taskForm.id = '';
            let newTime=new Date();
            if(newTime.getHours()<=23){
                newTime.setHours(newTime.getHours() + 1);
            }
            if(newTime.getMinutes()>0&&newTime.getMinutes()<15){
                newTime.setMinutes(0);
            }else if(newTime.getMinutes()>=15&&newTime.getMinutes()<30){
                newTime.setMinutes(15);
            }else if(newTime.getMinutes()>=30&&newTime.getMinutes()<45){
                newTime.setMinutes(30);
            }else if(newTime.getMinutes()>=45&&newTime.getMinutes()<60) {
                newTime.setMinutes(45);
            }else{
                newTime.setMinutes(60);
            }
            let endTime=new Date();
            if(endTime.getHours()<=22){
                endTime.setHours(endTime.getHours() + 2);
            }
            if(endTime.getMinutes()>0&&endTime.getMinutes()<15){
                endTime.setMinutes(0);
            }else if(endTime.getMinutes()>=15&&endTime.getMinutes()<30){
                endTime.setMinutes(15);
            }else if(endTime.getMinutes()>=30&&endTime.getMinutes()<45){
                endTime.setMinutes(30);
            }else if(endTime.getMinutes()>=45&&endTime.getMinutes()<60) {
                endTime.setMinutes(45);
            }else{
                endTime.setMinutes(60);
            }

            let startStr=""
            let startMinStr=""
            if(newTime.getHours()<10){
                startStr='0'+newTime.getHours();
            }else{
                startStr=newTime.getHours();
            }
            if(newTime.getMinutes()<10){
                startMinStr='0'+newTime.getMinutes();
            }else{
                startMinStr=newTime.getMinutes();
            }

            let endStr=""
            let endMinStr=""
            if(endTime.getHours()<10){
                endStr='0'+endTime.getHours();
            }else{
                endStr=endTime.getHours();
            }
            if(endTime.getMinutes()<10){
                endMinStr='0'+endTime.getMinutes();
            }else{
                endMinStr=endTime.getMinutes();
            }
            this.taskForm.startDate =startStr+":"+ startMinStr;
            this.taskForm.endDate = endStr+":"+ endMinStr;
            this.taskForm.calendarDate=date;
			
        },
        handleEventClick(info) {
            this.getStaffAllList();
            getTaskCalendarById(info).then(result => {
                Object.assign(this.taskForm, result.data.data);
            });
            this.optTitle = '修改日歷';
            this.dialogFormVisible = true;
        },
        // 保存事件
        saveEvent() {
            this.$refs.taskForm.validate((valid) => {
                    if (valid) {

                        if (this.taskForm.startDate == '') {
                            this.taskForm.startDate = 0
                        }
                        if (this.taskForm.endDate == '') {
                            this.taskForm.endDate = 0
                        }
                        if(this.taskForm.endDate!='' && this.taskForm.startDate!='') {
                            let oldStartDate = this.taskForm.startDate.split(":");
                            var oldEndDate = this.taskForm.endDate.split(":");

                            if ((oldStartDate[0]>oldEndDate[0]) && (oldStartDate[1]>oldEndDate[1])) {
                                return this.$message.error(this.$t('m.m_startmaxenddate'));
                            }
                            if ((oldEndDate[0]<oldStartDate[0]) && (oldEndDate[1]<oldStartDate[1])) {
                                return this.$message.error(this.$t('m.m_endminstartdate'));
                            }
                        }

                        var params = Object.assign({}, this.taskForm);

                        if (this.taskForm.id === undefined || this.taskForm.id === '') { // 新增
                            params.taskDate = Math.round(new Date(params.calendarDate).getTime() / 1000);
                           insertTaskCalendar(params).then(data => {
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message.success("新增成功！！");
                                    this.resetForm("taskForm");
                                    this.taskForm.startDate ="";
                                    this.taskForm.endDate = "";
                                    this.getTaskCalendarLists();
									
									
                                } else {
                                    this.$message.error(res.errmsg);
                                }
                            });
                        } else {//修改
                            updateTaskCalendar(params).then(data => {
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message.success("修改成功");
                                    this.resetForm("taskForm");
                                    this.taskForm.startDate ="";
                                    this.taskForm.endDate = "";
                                    this.getTaskCalendarLists();
                                } else {
                                    this.$message.error(res.errmsg);
                                }
                            });
                        }
                        this.dialogFormVisible = false;
                    }
            });
        },
        // 删除事件
        delEvent(id) {
            this.$confirm('你確定要删除任务日歷嗎?',this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(()=> {
                deleteTaskCalendarById(id).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        this.$message.success('刪除成功');
                        this.dialogFormVisible = false;
                        this.resetForm("taskForm");
                        this.getTaskCalendarLists();
                    }else{
                        this.$message.error("刪除失败！");
                    }
                });
            });

        },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },

    computed: {
        staff(){
            return this.$store.getters.staff;
        },
        custTaskAdd(){
            return this.$store.getters.hasPermission("TASK_ADD");
        },
        custTaskEditAll(){
            return this.$store.getters.hasPermission("TASK_EDIT_ALL");
        },
        custTaskEdit(){
            return this.$store.getters.hasPermission("TASK_EDIT");
        },custTaskDelete(){
            return this.$store.getters.hasPermission("TASK_DELETE");
        },
        canFile(){
            return this.$store.getters.hasPermission("TASK_FILE");
        },
        canFileAdd(){
            return this.$store.getters.hasPermission("TASK_FILE_ADD");
        },
        canFileDow(){
            return this.$store.getters.hasPermission("TASK_FILE_DOW");
        },
        canFileDel(){
            return this.$store.getters.hasPermission("TASK_FILE_DEL");
        },
    }
        }
</script>

<style>
    a {
        text-decoration: underline;
        color: #4B78FF;
    }
/* .el-calendar__body
{
	 border: 10px solid LightBLue;
} */

/* 电脑端時間列表样式 */
    .pcelcalendar .calendar-day{
        text-align: center;
        color: #202535;
        line-height: 30px;
        font-size: 12px;
		
		
    }
    .is-selected{
        color: #F8A535;
        /* font-size: 10px;
        margin-top: 5px; */
    }
	.pcelcalendar .el-calendar-table td
	{
		/* border: 1px solid #4B78FF;  */
	}
   .pcelcalendar .el-calendar-table .el-calendar-day {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 8px;
        height: 150px;
		 border: 1px solid #4B78FF;  
    }
    .pcelcalendar .el-calendar-table .el-calendar-click {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 8px;
        height: 10px;
    }
   .pcelcalendar .el-calendar-table thead th {
        padding: 6px 0;
        color: #606266;
        font-weight: normal;
        text-align: center;
    }
    /* #calendar .el-button-group>.el-button:not(:first-child):not(:last-child):after{
            content: '当月';
        } */
   .pcelcalendar .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev {
        opacity: 0.7;
    }
    .pcelcalendar .calendar-day,.is-selected{
        color: #000000;
    }
/* ---------------------------- */

/* 手机端時間列表样式 */
    .moblieElcalendar .calendar-day{
        text-align: center;
        color: #202535;
       /* line-height: 30px; */
        font-size: 12px;
		border: none;
		
    }
 /*   .is-selected{
        color: #F8A535;
      
    } */
	
	.moblieElcalendar .el-calendar-table td
	{
		/* border: 1px solid #4B78FF;  */
	}
   .moblieElcalendar .el-calendar-table .el-calendar-day {
      /*  -webkit-box-sizing: border-box;
        box-sizing: border-box; */
        padding: 8px;
       height: 50px;
	   
		
    }
     /* .is-selected
	{
		background-color:red;
	} */
	
	/* //current is-selected */
    .moblieElcalendar .el-calendar-table .el-calendar-click {
       /* -webkit-box-sizing: border-box; */
       /* box-sizing: border-box; */
        padding: 8px;
	/* 	background-color: red; */
       /* height: 10px; */
    }
   .moblieElcalendar .el-calendar-table thead th {
        padding: 6px 0;
        color: #606266;
        font-weight: normal;
        text-align: center;
    }
/* 	设置表格边框 */
	.moblieElcalendar .el-calendar-table tr td  {
	    border:0px red solid;
	 }
    /* #calendar .el-button-group>.el-button:not(:first-child):not(:last-child):after{
            content: '当月';
        } */
   .moblieElcalendar .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev {
        opacity: 0.7;
    }
    .moblieElcalendar .calendar-day,.is-selected{
        color: #0017ff;
		font-weight: bold;
		background-color:white !important;/* 修改选中背景色 */
    }
	.rightDate
	{
		float: right;
		background-color: rgba(39,116,244,0.2);
		color: #4B78FF;
		width: 20px;
		height: 20px;
		text-align: center;
		
	}
	/* --------------------------- */


    .fc-day-grid-event {
        margin: 1px 2px 0;
        padding: 0 1px;
		
    }
    .fc-event {
        position: relative;
        display: block;
        font-size: 0.85em;
        line-height: 1.2;
        border-radius: 3px;
        color: black;
    }
	.taskImg {
	        display: block;
	        cursor: zoom-in;
	        max-width: 100px;
	        max-height: 100px;
	    }
	    .taskImg.open{
	        cursor: zoom-out;
	        max-width: 100%;
	        max-height: 100%;
	    }
    .fc-event{
        border: 1px solid LightBLue;
        background-color:#4B78FF;/* //#4B78FF; */
        color: #000000;
    }
	#fc-eventone{
	   /* border: 1px solid LightBLue; */
	    background-color:#70f3ff;/* //#4B78FF; */
	    color: #000000;
	margin-left: -9px;
	margin-right: -9px;
	font-size: 12px;
line-height:13px;
	}
	 #fc-eventone2
	{
	 border: 1px solid #bce672; 
	background-color:#bce672;/* //#4B78FF; */
	color: #000000;	
	margin-left: -9px;
	margin-right: -9px;
	font-size: 12px;
line-height:13px;
	} 
    .fc-event,#fc-eventtwo {
        border: 1px solid PeachPuff;
        background-color: PeachPuff;
    }
</style>


// WEBPACK FOOTER //
// src/views/TaskCalendar.vue